import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "@/components/admin/calendar/components/calendar";

export const Route = createFileRoute("/dashboard/patients/$patientId/appointments")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Calendar />;
}
